import React from "react";

function Conditional(props) {
    return <h1>Some cool stuff about conditional rendering</h1>
    }
  


export default Conditional;